const sampleGames = [
    {
        id_gam: 1,
        name_gam: 'Catan',
        image_gam: 'https://cf.geekdo-images.com/W3Bsga_uLP9kO91gZ7H8yw__itemrep/img/IzYEUm_gWFuRFOL8gQYqGm5gU6A=/fit-in/246x300/filters:strip_icc()/pic2419375.jpg',
        difficulty_gam: 'Intermédiaire',
        genre_gam: 'Stratégie',
        genre2_gam: 'Négociation',
        genre3_gam: null,
        subgenre_gam: 'Gestion de ressources',
        subgenre2_gam: null,
        subgenre3_gam: null,
        min_player_gam: 3,
        max_player_gam: 4,
        playtime_gam: '60–90 min',
        minimum_age_gam: 10,
        language_gam: 'Français',
        publisher_gam: 'Kosmos',
        owner_gam: 'Robin',
    },
    {
        id_gam: 2,
        name_gam: 'Azul',
        image_gam: 'https://cf.geekdo-images.com/aPSHJO0d0XOpQR5X-wJonw__itemrep/img/q4uWd2nXGeEkKDR8Cc3NhXG9PmU=/fit-in/246x300/filters:strip_icc()/pic6973671.jpg',
        difficulty_gam: 'Débutant',
        genre_gam: 'Abstrait',
        genre2_gam: 'Puzzle',
        genre3_gam: null,
        subgenre_gam: 'Placement de tuiles',
        subgenre2_gam: null,
        subgenre3_gam: null,
        min_player_gam: 2,
        max_player_gam: 4,
        playtime_gam: '30–45 min',
        minimum_age_gam: 8,
        language_gam: 'Français',
        publisher_gam: 'Plan B Games',
        owner_gam: 'Robin',
    },
    {
        id_gam: 3,
        name_gam: 'Terraforming Mars',
        image_gam: 'https://cf.geekdo-images.com/wg9oOLcsKvDesSUdZQ4rxw__itemrep/img/ILMPFtR_Fms73jn0iesOFmKBz-0=/fit-in/246x300/filters:strip_icc()/pic3536616.jpg',
        difficulty_gam: 'Avancé',
        genre_gam: 'Stratégie',
        genre2_gam: 'Science-Fiction',
        genre3_gam: null,
        subgenre_gam: 'Engine building',
        subgenre2_gam: 'Gestion de ressources',
        subgenre3_gam: null,
        min_player_gam: 1,
        max_player_gam: 5,
        playtime_gam: '120–180 min',
        minimum_age_gam: 12,
        language_gam: 'Français',
        publisher_gam: 'Intrafin',
        owner_gam: 'Robin',
    },
    {
        id_gam: 4,
        name_gam: 'Codenames',
        image_gam: 'https://cf.geekdo-images.com/F_KDEu0GjdClml8N7c8Imw__itemrep/img/r0aGYbDNHnFEpOSVJPYMI4YqEfo=/fit-in/246x300/filters:strip_icc()/pic2582929.jpg',
        difficulty_gam: 'Débutant',
        genre_gam: 'Ambiance',
        genre2_gam: 'Déduction',
        genre3_gam: null,
        subgenre_gam: 'Association de mots',
        subgenre2_gam: null,
        subgenre3_gam: null,
        min_player_gam: 4,
        max_player_gam: 8,
        playtime_gam: '15–30 min',
        minimum_age_gam: 10,
        language_gam: 'Français',
        publisher_gam: 'Czech Games Edition',
        owner_gam: 'Robin',
    },
    {
        id_gam: 5,
        name_gam: 'Gloomhaven',
        image_gam: 'https://cf.geekdo-images.com/sZYp_3BTDGjh2unaZfZmuA__itemrep/img/0IdBVBEFMUmukqEagSpTSo5gZ0w=/fit-in/246x300/filters:strip_icc()/pic2437871.jpg',
        difficulty_gam: 'Expert',
        genre_gam: 'Aventure',
        genre2_gam: 'Stratégie',
        genre3_gam: 'Coopératif',
        subgenre_gam: 'Dungeon Crawler',
        subgenre2_gam: 'Legacy',
        subgenre3_gam: null,
        min_player_gam: 1,
        max_player_gam: 4,
        playtime_gam: '90–150 min',
        minimum_age_gam: 14,
        language_gam: 'Anglais',
        publisher_gam: 'Cephalofair Games',
        owner_gam: 'Robin',
    },
    {
        id_gam: 6,
        name_gam: '7 Wonders',
        image_gam: 'https://cf.geekdo-images.com/35h9Za_JvMMMtx_92kT0Jg__itemrep/img/TIXgNi3NnvOHm40IjD-P2kBnmJE=/fit-in/246x300/filters:strip_icc()/pic7149798.jpg',
        difficulty_gam: 'Intermédiaire',
        genre_gam: 'Stratégie',
        genre2_gam: 'Draft',
        genre3_gam: null,
        subgenre_gam: 'Civilisation',
        subgenre2_gam: 'Développement',
        subgenre3_gam: null,
        min_player_gam: 2,
        max_player_gam: 7,
        playtime_gam: '30–45 min',
        minimum_age_gam: 10,
        language_gam: 'Français',
        publisher_gam: 'Repos Production',
        owner_gam: 'Robin',
    },
    {
        id_gam: 7,
        name_gam: 'Dixit',
        image_gam: 'https://cf.geekdo-images.com/J39YqbmSKiMBgYkeIjATkA__itemrep/img/DN0VPSMVUjp2hq8sDnlAdVCrVeA=/fit-in/246x300/filters:strip_icc()/pic6738083.jpg',
        difficulty_gam: 'Débutant',
        genre_gam: 'Ambiance',
        genre2_gam: 'Créativité',
        genre3_gam: null,
        subgenre_gam: 'Narration',
        subgenre2_gam: null,
        subgenre3_gam: null,
        min_player_gam: 3,
        max_player_gam: 8,
        playtime_gam: '30 min',
        minimum_age_gam: 8,
        language_gam: 'Français',
        publisher_gam: 'Libellud',
        owner_gam: 'Robin',
    },
    {
        id_gam: 8,
        name_gam: 'Pandemic',
        image_gam: 'https://cf.geekdo-images.com/S3ybV1LAp-8SnHIXLLjVqA__itemrep/img/FcSGmEOIBETOKOGz-yL7AIDbJIE=/fit-in/246x300/filters:strip_icc()/pic1534148.jpg',
        difficulty_gam: 'Intermédiaire',
        genre_gam: 'Coopératif',
        genre2_gam: 'Stratégie',
        genre3_gam: null,
        subgenre_gam: 'Gestion de crise',
        subgenre2_gam: null,
        subgenre3_gam: null,
        min_player_gam: 2,
        max_player_gam: 4,
        playtime_gam: '45–60 min',
        minimum_age_gam: 8,
        language_gam: 'Français',
        publisher_gam: 'Z-Man Games',
        owner_gam: 'Robin',
    },
];

export default sampleGames;
